<template>
  <div class="component selectable paragraph" :class="{ active: selected == component, hovered: hovered == component }" :style="{ fontSize: component.settings.fontSize + 'px', color: component.settings.fontColor, fontWeight: component.settings.fontWeight, textAlign: component.settings.align }">
    <div class="component-type">{{ component.component }}</div>
    <div>{{component.settings.content}}</div>
  </div>
</template>

<script>
import VueResizable from 'vue-resizable'

export default {
  name: 'Paragraph',
  props: {
    component: {},
    selected: {},
    hovered: {}
  }
}
</script>

<style scoped lang="scss">
</style>